module.exports = __webpack_public_path__ + "static/media/vegitables_72.fde55a4f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_72.csv
// module id = 660
// module chunks = 0